export default function EmptyState() {
    return (
        <div className="rounded-xl border border-dashed border-gray-300 px-6 py-10 text-center dark:border-gray-700">
            <p className="text-sm font-medium text-gray-700 dark:text-gray-300">
                Nessuna conversione ancora
            </p>
            <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                Carica un file PDF qui sopra per vederlo apparire in questo elenco.
            </p>
        </div>
    );
}
